import axios from 'axios'
import Qs from 'qs'
import { URL_CONTENT_TYPE_FORM, URL_DOMAIN } from './consts'
import router from '@/router/index'
import md5 from 'js-md5';
import Vue from 'vue';
import { Toast } from 'vant';

Vue.use(Toast);

const STATIC_URL = 'https://www.livemusichina.com';

// create an axios instance
const service = axios.create({
    baseURL: STATIC_URL,
    withCredentials: true, // send cookies when cross-domain requests
    timeout: 20000, // request timeout
})

// request interceptor
service.interceptors.request.use(
    config => {
        console.log(config)
        if (config.url != '/content/api/cont/pay/member/check_scan_pay' && config.url != '/weixin/api/ma/wxuser/exempt/check_login_qrcode') {
            Toast.loading({
                duration: 0, // 持续展示 toast
                message: '加载中...',
                forbidClick: true,
            });
        }

        if (config.method === 'post') {
            const contentType = config.headers['Content-Type']
            const param = config.data
            if (contentType === URL_CONTENT_TYPE_FORM) {
                config.data = Qs.stringify(param)
            }
        }
        let token = window.localStorage.getItem("token")
        config.headers['third-session'] = token
        config.headers['app-id'] = 'wxa73b5ed4031587b3'
        return config
    },
    error => {
        // do something with request error
        console.log(error) // for debug
        return Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    /**
     * If you want to get http information such as headers or status
     * Please return  response => response
     */

    /**
     * Determine the request status by custom code
     * Here is just an example
     * You can also judge the status by HTTP Status Code
     */
    response => {
        const res = response.data
        Toast.clear()
            // if the custom code is not 20000, it is judged as an error.
        if (res.code !== 0) {
            if (res.code === 60002 || res.code === 60001) {
                window.localStorage.removeItem("token")
                Vue.prototype.$login({});
            } else {
                if (res.code !== 508 && res.code !== 7502) {
                    Toast(res.msg);
                }
            }
            return Promise.reject(res);
        } else {
            return res
        }
    },
    error => {
        console.log('err' + error) // for debug
        Toast(error);
        return Promise.reject(error)
    }
)

export default service



// WEBPACK FOOTER //
// ./src/network/request.js